import React, { useState } from 'react';
import PropTypes from 'prop-types';
import InlineError from '../InlineError';
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import './style.css';
{/* <InputField
  required
  type="text"
  name="phone"
  label={changeLanguage(language, "tel", "label")}
  containerClass={"form-group"}
  placeholder={changeLanguage(
    language,
    "tel",
    "placeholder"
  )}
  className="form-input-field"
  value={formData.phone}
  onChange={handleInputChange}
  error={error.phone}
  onBlur={onBlur}
  hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
/> */}
const TextareaField = (props) => {
  const {
    containerClass, value,
    error, onChange, label, required, name,
    hasInvalidSubmitOccurred, placeholder,
    disabled, onBlur, getRef = "", className, rows,maxRows, labelClass, ...rest
  } = props;
  const useStyles = makeStyles((theme) => ({
    // input: {
    //   backgroundColor: "white"
    // }
  }));
  const [touched, setTouched] = useState(false);
  const classes = useStyles();

  const handleInputBlur = (e, name) => {
    setTouched(true);
    if (onBlur) {
      onBlur(e, name);
    }
  };


  const displayError = touched || hasInvalidSubmitOccurred;

  return (
    <div
      className={`input-field-container textarea-container ${containerClass || ''} ${displayError && error ? 'error' : ''}`}
    >
      <div className="inner-wrap">
        {label &&
          <label
            htmlFor=""
            className={`mb-15 ${labelClass}`}
          >
            {label}
            {
              required
              && (
                <span className="required">&nbsp;*</span>
              )
            }
          </label>}
        {
          <TextField
            ref={getRef}
            name={name}
            disabled={disabled}
            value={value}
            className={`input-element ${value ? 'filled' : ''} ${className} ${displayError && error ? 'error' : ''}`}
            onChange={e => onChange(e, name)}
            onBlur={e => handleInputBlur(e, name)}
            placeholder={placeholder}
            rows={rows}
            InputProps={{ className: classes.input }}
            maxRows={maxRows}
            {...rest}
            multiline
              // rows={2}
              // maxRows={4}
          />
        }
      </div>
      {
        displayError && error && (
          <InlineError message={error} />
        )
      }
    </div>
  );

}


TextareaField.propTypes = {
  value: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  required: PropTypes.bool,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  onBlur: PropTypes.func,
  hasInvalidSubmitOccurred: PropTypes.bool,
  getRef: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]),
  className: PropTypes.string,
  labelClass: PropTypes.string,
  containerClass: PropTypes.string
};

TextareaField.defaultProps = {
  disabled: false,
  value: '',
  error: '',
  onChange: () => { },
  label: '',
  required: false,
  name: '',
  mask: '',
  placeholder: '',
  containerClass: '',
  onBlur: () => { },
  hasInvalidSubmitOccurred: false,
  getRef: () => { },
  className: '',
  labelClass: '',
};

export default TextareaField;